import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
    Button,
} from 'antd';

import { RedoOutlined, RobotOutlined } from '@ant-design/icons';

class Error extends Component {
    render() {
        const { refresh } = this.props;
        return (
            <div style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <div><RobotOutlined style={{ fontSize: 34 }} /></div>
                <div style={{ marginTop: 10, marginBottom: 15, textAlign: 'center' }}> Something went wrong. <br /> Please refresh or reset the API key if the error persists.</div>
                <Button icon={<RedoOutlined />} onClick={refresh}>Refresh</Button>
            </div>
        );
    }
}

export default Error;